<div *ngIf="!editing; else editMode" class="editable-view">
  <span class="editable-value">{{ value || '-' }}</span>
  <button mat-icon-button class="edit-button" (click)="editing = true">
    <mat-icon>edit</mat-icon>
  </button>
</div>

<ng-template #editMode>
  <div class="editable-edit">
    <mat-form-field appearance="outline" class="editable-field">
      <input *ngIf="type=='text'" matInput [(ngModel)]="value">

      <mat-select *ngIf="type=='select'" [(ngModel)]="value">
        <mat-option *ngFor="let option of options" [value]="option">
          {{option}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="editable-actions">
      <button mat-icon-button color="primary" (click)="editing = false; _inputUpdated()">
        <mat-icon>check</mat-icon>
      </button>
      <button mat-icon-button (click)="editing = false">
        <mat-icon>close_small</mat-icon>
      </button>
    </div>
  </div>
</ng-template>
